/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import withErrorHandler from '../../../hoc/with-error-handler';

import { ClockCircleOutlined } from '@ant-design/icons';

import axios from '../../../shared/axios';

import { NoteModal } from '../note-modal';
import { NotesRequestBase } from '../../../shared/models';

export type QuickNoteButtonProps = {} & NotesRequestBase;

const QuickNoteButton: React.FC<QuickNoteButtonProps> = ({
  insuredId,
  agencyId,
  policyId,
  taskId,
  agentId,
  opportunityId,
  claimId,
  serviceRequestId,
  ownerType,
}) => {
  const [modalVisible, setModalVisible] = useState<boolean>(false);

  const baseRequestParams: NotesRequestBase = {
    insuredId,
    agencyId,
    policyId,
    taskId,
    agentId,
    opportunityId,
    claimId,
    serviceRequestId,
    ownerType,
  };

  const handleOpenModal = (event: React.MouseEvent): void => {
    event.preventDefault();
    event.stopPropagation();

    setModalVisible(true);
  };

  const handleCloseModal = (): void => setModalVisible(false);

  return (
    <>
      {/* todo: this button if for angular or for normal react antd app */}
      {/* <Button
        style={{ display: 'block' }}
        icon={<ClockCircleOutlined />}
        type='link'
        title='Add Reminder / Quick Note'
        onClick={handleOpenModal} /> */}

      <a
        href="#"
        className="text-decoration-none header-system-icon"
        style={{ padding: '10px 15px' }}
        title="Add Reminder / Quick Note"
        onClick={(event) => handleOpenModal(event)}
      >
        <ClockCircleOutlined />
      </a>

      {/* DO NOT WRAP IN TERNARY EXPRESSION */}
      <NoteModal visible={modalVisible} isQuickNote={true} close={handleCloseModal} baseRequestParams={baseRequestParams} />
    </>
  );
};

export default withErrorHandler(QuickNoteButton, axios);
